import styled from 'styled-components';
import { spin } from '~styles/animations';


export const Container = styled.div<{ $compact?: boolean }>`
  width: 100%;
  height: ${({ $compact }) => ($compact ? '14rem' : '40rem')};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  p {
    color: #767778;
    font-size: 1.25rem;
    margin-top: 1rem;
  }

  svg {
    stroke: #767778;
    width: 2.5rem;
    height: 2.5rem;
    animation: ${spin} 2s linear infinite;
  }
`;
